import React from "react"
import Button from "../Button"

import "./purchaseCard.scss"

const PurchaseCard = (props) => {
  let {
    recommended,
    description,
    buttonText,
    buttonAction,
    buttonClasses,
  } = props

  return (
    <div className={`purchase-card-container ${recommended ? "shaded" : ""}`}>
      {!!recommended && (
        <div className="purchase-card-header">
          Inquire today about our Subscription plans
        </div>
      )}
      {!!description && (
        <div className="purchase-card-description">{description}</div>
      )}
      <Button
        classes={
          buttonClasses || [
            recommended ? "btn-marketing-style2 btn-outline" : "btn-primary",
          ]
        }
        action={buttonAction}
        fullWidth
        data-cy={props["data-cy"]}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default PurchaseCard
